<template>
  <div class="power-calc">
    <div class="power-calc__wrapper">
      <DeviceCategories />
      <CalcResult v-if="allItems.length" />
      <div
        class="ui-rich-text"
        v-html="
          _T(
            '@HTML Calculator for calculating the power of electrical appliances',
          )
        "
      />
    </div>
  </div>
</template>

<script setup>
import DeviceCategories from "~/modules/calculators/powerCalculator/components/sections/DeviceCategories.vue";
import CalcResult from "~/modules/calculators/powerCalculator/components/sections/CalcResult.vue";
import { usePowerCalcStore } from "~/store/powerCalcStore";

const powerCalcStore = usePowerCalcStore();

const allItems = computed(() => {
  return powerCalcStore.getAllSelectedItems;
});
</script>

<style lang="scss" scoped>
.power-calc {
  min-height: 100vh;

  padding: 64px 16px 100px;
  gap: 48px;

  &__wrapper {
    @extend %width-main;

    @include flex-container(column, null);

    gap: 16px;
    margin: 0 auto;
  }
}
</style>
